import { motion } from "framer-motion";
import { CalendarDays, ArrowUpRight } from "lucide-react";
import { EVENTS, IMAGES } from "@/data/site";
import { Reveal } from "@/components/site/Reveal";
import { Button } from "@/components/ui/button";
import { scrollToId } from "@/lib/scroll";

export default function EventsSchedule() {
  return (
    <section
      id="events"
      data-testid="events-section"
      className="relative bg-[#1C2541] py-16 md:py-24"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="mb-14 flex items-end justify-between gap-6">
          <div>
            <Reveal>
              <span className="font-label text-xs text-primary">The Weekly Lineup</span>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-4 font-display text-5xl md:text-7xl text-[#F8F5F2]">
                What's on <span className="text-primary">this week.</span>
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.1} className="hidden md:block">
            <CalendarDays className="h-12 w-12 text-primary/70" />
          </Reveal>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {EVENTS.map((e, i) => (
            <Reveal key={e.title} delay={i * 0.07}>
              <motion.div
                whileHover={{ y: -6 }}
                transition={{ type: "spring", stiffness: 200, damping: 18 }}
                className="group h-full rounded-md border border-white/10 bg-[#0B132B] p-7 flex flex-col"
              >
                <span className="font-label text-[11px] text-primary">{e.day}</span>
                <h3 className="mt-4 font-display text-3xl text-[#F8F5F2]">
                  {e.title}
                </h3>
                <p className="mt-2 text-sm text-[#F8F5F2]/70 flex-1">{e.detail}</p>
                <div className="mt-6 pt-4 border-t border-white/10 flex items-center justify-between">
                  <span className="text-sm text-[#F8F5F2]/85">{e.time}</span>
                  <span className="h-2 w-2 rounded-full bg-primary group-hover:scale-150 transition-transform" />
                </div>
              </motion.div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div
            data-testid="events-cta"
            className="mt-6 relative overflow-hidden rounded-md border border-white/10"
          >
            <img
              src={IMAGES.music}
              alt="Live band at Alley Pub"
              className="absolute inset-0 h-full w-full object-cover"
              style={{ filter: "brightness(0.4)" }}
            />
            <div className="relative z-10 flex flex-col md:flex-row md:items-center justify-between gap-6 p-8 md:p-12">
              <div>
                <h3 className="font-display text-3xl md:text-4xl text-[#F8F5F2]">
                  Got a band? Play our stage.
                </h3>
                <p className="mt-2 text-[#F8F5F2]/80 max-w-lg">
                  Live music Fridays & Saturdays. Reach out to get booked.
                </p>
              </div>
              <Button
                data-testid="events-contact-btn"
                onClick={() => scrollToId("contact")}
                className="rounded-full h-12 px-8 font-label text-xs shrink-0 hover:-translate-y-0.5 active:scale-95 transition-transform"
              >
                Get In Touch <ArrowUpRight className="h-4 w-4" />
              </Button>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
